import { ComponentFrameworkPrintTemplate } from '@utils/component-framework';
import { img } from './organism.print.style.js';
import { jsx } from 'react/jsx-runtime';

function PrintLayout(props) {
  return /*#__PURE__*/jsx(ComponentFrameworkPrintTemplate, {
    children: /*#__PURE__*/jsx("img", {
      ref: props.ref,
      alt: "",
      className: img
    })
  });
}

export { PrintLayout };
//# sourceMappingURL=organism.print.js.map
